// TDS / TCS section labels as per the Income-tax Act, 2025 (sec 392 / 393 / 394 + payment code), old 1961 section as reference.
export const tdsKind = (r) => (String(r.new_section || "").startsWith("394") ? "TCS" : "TDS");

export const tdsLabel = (r) => {
  const pct = String(r.description || "").includes("%") ? "" : ` (${r.rate}%)`;
  return `Sec ${r.new_section || "\u2014"} \u00b7 Code ${r.section} \u00b7 ${r.description}${pct}`;
};

export const tdsOption = (r) => ({
  value: r.section,
  label: tdsLabel(r),
  sublabel: `${tdsKind(r)} \u00b7 Income-tax Act 2025${r.old_section ? ` \u00b7 earlier sec ${r.old_section} (Act 1961)` : ""}`,
});
